// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

common.View.create('canvas.blocks.custom.3columnSlider.Block', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider()
    {
        new Swiper(this.element.find('.swiper-container').get(0), {
            spaceBetween: 32,
            loop: false,
            centeredSlides: true,
            initialSlide: 1,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                992: {
                    slidesPerView: 2.3,
                    spaceBetween: 32,
                },
            },
            pagination: {
                el: this.element.find('.swiper-pagination').get(0),
                clickable: true,
            },
        });
    }

});